import CartPage from './CartPage';

export default CartPage;



// WEBPACK FOOTER //
// ./src/containers/CartPage/index.js